// After the system is updated, a screen still open from before asks for files that are no longer there. The page then
// reloads itself once and gets the new version; it never reloads in a loop (once a minute at most).

const KEY = 'pms.updateReloadAt';

/** A screen's file could not be loaded (Chrome, Firefox and Safari word it differently). */
export function isUpdateError(e: unknown): boolean {
  const msg = e instanceof Error ? e.message : String(e ?? '');
  return /dynamically imported module|Importing a module script failed|Unable to preload CSS/i.test(msg);
}

/** Reload to fetch the new version, unless that was just tried. True when the page is reloading. */
export function reloadForUpdate(): boolean {
  try {
    if (Date.now() - (Number(sessionStorage.getItem(KEY)) || 0) < 60_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // Without this tab's storage a reload could repeat for ever: the error page offers it instead.
    return false;
  }
  window.location.reload();
  return true;
}
